"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2767],{

/***/ 29254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ 37982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; }
/* harmony export */ });
/* unused harmony exports Heading, H5, H6 */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(92222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(97375);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(24614);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(98352);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26153);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(48189);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }




















var _excluded = ["analyticsName", "trackImpression", "headingStyle", "as", "Component"],
  _excluded2 = ["as", "analyticsName"];
function cov_nvx2l5u8j() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Heading/Heading.tsx";
  var hash = "501e3d5051cbcdb6b76fdc06943a6e278d75b840";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Heading/Heading.tsx",
    statementMap: {
      "0": {
        start: {
          line: 44,
          column: 28
        },
        end: {
          line: 60,
          column: 2
        }
      },
      "1": {
        start: {
          line: 51,
          column: 20
        },
        end: {
          line: 51,
          column: 92
        }
      },
      "2": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 59,
          column: 4
        }
      },
      "3": {
        start: {
          line: 187,
          column: 23
        },
        end: {
          line: 215,
          column: 2
        }
      },
      "4": {
        start: {
          line: 188,
          column: 15
        },
        end: {
          line: 188,
          column: 55
        }
      },
      "5": {
        start: {
          line: 189,
          column: 17
        },
        end: {
          line: 189,
          column: 64
        }
      },
      "6": {
        start: {
          line: 190,
          column: 16
        },
        end: {
          line: 190,
          column: 73
        }
      },
      "7": {
        start: {
          line: 191,
          column: 27
        },
        end: {
          line: 191,
          column: 66
        }
      },
      "8": {
        start: {
          line: 191,
          column: 41
        },
        end: {
          line: 191,
          column: 55
        }
      },
      "9": {
        start: {
          line: 194,
          column: 2
        },
        end: {
          line: 205,
          column: 3
        }
      },
      "10": {
        start: {
          line: 195,
          column: 4
        },
        end: {
          line: 204,
          column: 6
        }
      },
      "11": {
        start: {
          line: 207,
          column: 2
        },
        end: {
          line: 214,
          column: 4
        }
      },
      "12": {
        start: {
          line: 223,
          column: 51
        },
        end: {
          line: 225,
          column: 1
        }
      },
      "13": {
        start: {
          line: 224,
          column: 2
        },
        end: {
          line: 224,
          column: 49
        }
      },
      "14": {
        start: {
          line: 226,
          column: 51
        },
        end: {
          line: 228,
          column: 1
        }
      },
      "15": {
        start: {
          line: 227,
          column: 2
        },
        end: {
          line: 227,
          column: 49
        }
      },
      "16": {
        start: {
          line: 229,
          column: 51
        },
        end: {
          line: 231,
          column: 1
        }
      },
      "17": {
        start: {
          line: 230,
          column: 2
        },
        end: {
          line: 230,
          column: 49
        }
      },
      "18": {
        start: {
          line: 232,
          column: 51
        },
        end: {
          line: 234,
          column: 1
        }
      },
      "19": {
        start: {
          line: 233,
          column: 2
        },
        end: {
          line: 233,
          column: 49
        }
      },
      "20": {
        start: {
          line: 235,
          column: 51
        },
        end: {
          line: 237,
          column: 1
        }
      },
      "21": {
        start: {
          line: 236,
          column: 2
        },
        end: {
          line: 236,
          column: 49
        }
      },
      "22": {
        start: {
          line: 238,
          column: 51
        },
        end: {
          line: 240,
          column: 1
        }
      },
      "23": {
        start: {
          line: 239,
          column: 2
        },
        end: {
          line: 239,
          column: 49
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 86
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 50
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 187,
            column: 54
          },
          end: {
            line: 187,
            column: 55
          }
        },
        loc: {
          start: {
            line: 187,
            column: 96
          },
          end: {
            line: 215,
            column: 1
          }
        },
        line: 187
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 191,
            column: 35
          },
          end: {
            line: 191,
            column: 36
          }
        },
        loc: {
          start: {
            line: 191,
            column: 41
          },
          end: {
            line: 191,
            column: 55
          }
        },
        line: 191
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 223,
            column: 51
          },
          end: {
            line: 223,
            column: 52
          }
        },
        loc: {
          start: {
            line: 224,
            column: 2
          },
          end: {
            line: 224,
            column: 49
          }
        },
        line: 224
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 226,
            column: 51
          },
          end: {
            line: 226,
            column: 52
          }
        },
        loc: {
          start: {
            line: 227,
            column: 2
          },
          end: {
            line: 227,
            column: 49
          }
        },
        line: 227
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 229,
            column: 51
          },
          end: {
            line: 229,
            column: 52
          }
        },
        loc: {
          start: {
            line: 230,
            column: 2
          },
          end: {
            line: 230,
            column: 49
          }
        },
        line: 230
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 232,
            column: 51
          },
          end: {
            line: 232,
            column: 52
          }
        },
        loc: {
          start: {
            line: 233,
            column: 2
          },
          end: {
            line: 233,
            column: 49
          }
        },
        line: 233
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 235,
            column: 51
          },
          end: {
            line: 235,
            column: 52
          }
        },
        loc: {
          start: {
            line: 236,
            column: 2
          },
          end: {
            line: 236,
            column: 49
          }
        },
        line: 236
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 238,
            column: 51
          },
          end: {
            line: 238,
            column: 52
          }
        },
        loc: {
          start: {
            line: 239,
            column: 2
          },
          end: {
            line: 239,
            column: 49
          }
        },
        line: 239
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 188,
            column: 15
          },
          end: {
            line: 188,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 188,
            column: 33
          },
          end: {
            line: 188,
            column: 43
          }
        }, {
          start: {
            line: 188,
            column: 46
          },
          end: {
            line: 188,
            column: 55
          }
        }],
        line: 188
      },
      "1": {
        loc: {
          start: {
            line: 189,
            column: 18
          },
          end: {
            line: 189,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 189,
            column: 18
          },
          end: {
            line: 189,
            column: 20
          }
        }, {
          start: {
            line: 189,
            column: 25
          },
          end: {
            line: 189,
            column: 40
          }
        }],
        line: 189
      },
      "2": {
        loc: {
          start: {
            line: 190,
            column: 50
          },
          end: {
            line: 190,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 190,
            column: 50
          },
          end: {
            line: 190,
            column: 54
          }
        }, {
          start: {
            line: 190,
            column: 58
          },
          end: {
            line: 190,
            column: 60
          }
        }],
        line: 190
      },
      "3": {
        loc: {
          start: {
            line: 194,
            column: 2
          },
          end: {
            line: 205,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 2
          },
          end: {
            line: 205,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 194
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "501e3d5051cbcdb6b76fdc06943a6e278d75b840"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_nvx2l5u8j = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_nvx2l5u8j();

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable jsx-a11y/heading-has-content */







/** bricks.opendoor.com/?path=/docs/core-heading */

var HeadingWithTracking = (cov_nvx2l5u8j().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_22__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    headingStyle = _ref.headingStyle,
    as = _ref.as,
    Component = _ref.Component,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_nvx2l5u8j().f[0]++;
  var inViewRef = (cov_nvx2l5u8j().s[1]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_23__/* .useTrackComponentInView */ .O)('textViewEvent', trackImpression, analyticsName));
  cov_nvx2l5u8j().s[2]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(Component
  // __css has a lower priority than sx
  , _extends({
    __css: headingStyle,
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_24__/* .useMergeRefs */ .qq)(inViewRef, ref)
  }, props));
}));

/**
 * Heading composes a Box component and supports all the same style props.
 * Heading should be used for rendering html heading elements.
 *
 * It renders an h1 by default, but the heading level that is rendered can be
 * controlled using the optional size prop. The bricks design system theme only
 * supports h1-h4. Please use non-standard font/line-height sizes with caution
 * only if designers agree if a size exception is absolutely warranted as this
 * component intentionally overrides the design system standards
 *
 * Heading Variations
 *
 *
 * ----------------------
 *
 * It renders an `h1` by default, but the heading level that is rendered can be
 * controlled using the optional `level` prop, which accepts integers 1 - 4
 * since the Bricks design system theme only supports `h1` - `h4`.
 *
 * ###
 *
 * Shorthand components
 *
 * Shorthand components `H1`, `H2`, `H3`, and `H4` can be used to render a
 * `Heading` at levels 1, 2, 3 and 4 respectively.
 *
 * ###
 *
 * Heading Sizes
 *
 * The size options range from the very smallest (`80`) to the largest (`260`).
 * Consumers of the design system should never have to explicitly specify the
 * tokens or pixel values for `fontSize`, `lineHeight`, and other type styles.
 * Instead, by using the `size` prop on the typography components, type styles
 * will not only be standardized but also responsive as specified by design
 * standards.
 *
 * The size prop is not responsive but rather handles any responsive font sizes
 * under the hood. For example, size 210 is equal to `48px` on desktop and
 * tablet but `40px` on mobile.
 *
 * Heading size variations
 * ---------------------------------------------------------------------------------------------------
 *
 * "80"
 *
 * "90"
 *
 * "100"
 *
 * "110"
 *
 * "120"
 *
 * "130"
 *
 * "140"
 *
 * "150"
 *
 * "160"
 *
 * "170"
 *
 * "180"
 *
 * "190"
 *
 * "200"
 *
 * "210"
 *
 * "220"
 *
 * "230"
 *
 * "240"
 *
 * "250"
 *
 * "260"
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Header tags (h1, h2, etc.) are required when appropriate. It is possible,
 * using CSS, to style text as large, bold text to make it look like a heading,
 * but this visual information is not conveyed to screen reader users.**The
 * semantic meaning of a heading HTML element is critical to convey the
 * programmatic meaning to assistive technology and to its users, who may not be
 * able to see the large, bold text.**
 *
 * ###
 *
 * ✅ Pass
 *
 * <Heading size="h2">Title</Heading>
 *
 *
 * ###
 *
 * 🛑 Fail
 *
 * <Text fontSize="s5" fontWeight="bold"> Title </Text>
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Heading` is set up to track impression events:
 *
 * To track impression events in the heading pass: 1) a non-empty
 * `analyticsName` 2) pass `trackImpression={true}` Heading impression events
 * will only be tracked the first time that the heading enters the viewport.
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_heading\_view\_event for heading
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
var Heading = (cov_nvx2l5u8j().s[3]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_22__/* .forwardRef */ .Gp)(function (_ref2, ref) {
  var _ref3, _ref4;
  var as = _ref2.as,
    analyticsName = _ref2.analyticsName,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_nvx2l5u8j().f[1]++;
  var size = (cov_nvx2l5u8j().s[4]++, 'size' in props ? (cov_nvx2l5u8j().b[0][0]++, props.size) : (cov_nvx2l5u8j().b[0][1]++, undefined));
  var asProp = (cov_nvx2l5u8j().s[5]++, (_ref3 = (cov_nvx2l5u8j().b[1][0]++, as)) !== null && _ref3 !== void 0 ? _ref3 : (cov_nvx2l5u8j().b[1][1]++, size));
  var style = (cov_nvx2l5u8j().s[6]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_25__/* .useStyleConfig */ .mq)('Heading', _objectSpread({
    size: (_ref4 = (cov_nvx2l5u8j().b[2][0]++, size)) !== null && _ref4 !== void 0 ? _ref4 : (cov_nvx2l5u8j().b[2][1]++, as)
  }, props)));
  var HeadingComponent = (cov_nvx2l5u8j().s[7]++, (0,react__WEBPACK_IMPORTED_MODULE_21__.useMemo)(function () {
    cov_nvx2l5u8j().f[2]++;
    cov_nvx2l5u8j().s[8]++;
    return (0,_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_26__/* .bricks */ .G)(asProp);
  }, [asProp]));

  // Now that HeadingComponent is memoized this distinction shouldn't be necessary anymore
  cov_nvx2l5u8j().s[9]++;
  if (analyticsName) {
    cov_nvx2l5u8j().b[3][0]++;
    cov_nvx2l5u8j().s[10]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(HeadingWithTracking, _extends({
      as: asProp,
      ref: ref,
      headingStyle: style,
      analyticsName: "".concat(analyticsName, "-").concat(asProp),
      Component: HeadingComponent
    }, props));
  } else {
    cov_nvx2l5u8j().b[3][1]++;
  }
  cov_nvx2l5u8j().s[11]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(HeadingComponent
  // __css has a lower priority than sx
  , _extends({
    __css: style,
    ref: ref
  }, props));
}));

////////////////////////////////////////////////////////////////////////////////
// Shorthand aliases for the different heading levels.
////////////////////////////////////////////////////////////////////////////////
cov_nvx2l5u8j().s[12]++;
var H1 = function H1(props) {
  cov_nvx2l5u8j().f[3]++;
  cov_nvx2l5u8j().s[13]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(Heading, _extends({
    size: "UNSAFE_h1",
    as: "h1"
  }, props));
};
cov_nvx2l5u8j().s[14]++;
var H2 = function H2(props) {
  cov_nvx2l5u8j().f[4]++;
  cov_nvx2l5u8j().s[15]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(Heading, _extends({
    size: "UNSAFE_h2",
    as: "h2"
  }, props));
};
cov_nvx2l5u8j().s[16]++;
var H3 = function H3(props) {
  cov_nvx2l5u8j().f[5]++;
  cov_nvx2l5u8j().s[17]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(Heading, _extends({
    size: "UNSAFE_h3",
    as: "h3"
  }, props));
};
cov_nvx2l5u8j().s[18]++;
var H4 = function H4(props) {
  cov_nvx2l5u8j().f[6]++;
  cov_nvx2l5u8j().s[19]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(Heading, _extends({
    size: "UNSAFE_h4",
    as: "h4"
  }, props));
};
cov_nvx2l5u8j().s[20]++;
var H5 = function H5(props) {
  cov_nvx2l5u8j().f[7]++;
  cov_nvx2l5u8j().s[21]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "UNSAFE_h5",
    as: "h5"
  }, props));
};
cov_nvx2l5u8j().s[22]++;
var H6 = function H6(props) {
  cov_nvx2l5u8j().f[8]++;
  cov_nvx2l5u8j().s[23]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "UNSAFE_h6",
    as: "h6"
  }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);

/***/ }),

/***/ 47208:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* unused harmony export Link */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(29254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(97375);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(24614);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(98352);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26153);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(48189);
/* harmony import */ var _Flex_index_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(93298);
/* harmony import */ var _Icon_index_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(49154);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }




















var _excluded = ["analyticsName", "trackImpression", "onClick", "leftIcon", "rightIcon", "disabled", "href", "children"];
function cov_10uyfywcnq() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Link/Link.tsx";
  var hash = "624d8474d97852b7945b5760b09a6cb954b8ba19";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Link/Link.tsx",
    statementMap: {
      "0": {
        start: {
          line: 167,
          column: 20
        },
        end: {
          line: 247,
          column: 1
        }
      },
      "1": {
        start: {
          line: 182,
          column: 21
        },
        end: {
          line: 182,
          column: 95
        }
      },
      "2": {
        start: {
          line: 183,
          column: 19
        },
        end: {
          line: 186,
          column: 6
        }
      },
      "3": {
        start: {
          line: 187,
          column: 34
        },
        end: {
          line: 187,
          column: 56
        }
      },
      "4": {
        start: {
          line: 188,
          column: 22
        },
        end: {
          line: 188,
          column: 94
        }
      },
      "5": {
        start: {
          line: 189,
          column: 23
        },
        end: {
          line: 189,
          column: 51
        }
      },
      "6": {
        start: {
          line: 191,
          column: 24
        },
        end: {
          line: 203,
          column: 5
        }
      },
      "7": {
        start: {
          line: 193,
          column: 8
        },
        end: {
          line: 195,
          column: 9
        }
      },
      "8": {
        start: {
          line: 194,
          column: 10
        },
        end: {
          line: 194,
          column: 89
        }
      },
      "9": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 199,
          column: 9
        }
      },
      "10": {
        start: {
          line: 198,
          column: 10
        },
        end: {
          line: 198,
          column: 21
        }
      },
      "11": {
        start: {
          line: 205,
          column: 42
        },
        end: {
          line: 217,
          column: 5
        }
      },
      "12": {
        start: {
          line: 219,
          column: 42
        },
        end: {
          line: 223,
          column: 5
        }
      },
      "13": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 239,
          column: 5
        }
      },
      "14": {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 238,
          column: 8
        }
      },
      "15": {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 245,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 168,
            column: 2
          },
          end: {
            line: 168,
            column: 3
          }
        },
        loc: {
          start: {
            line: 181,
            column: 7
          },
          end: {
            line: 246,
            column: 3
          }
        },
        line: 181
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 192,
            column: 6
          },
          end: {
            line: 192,
            column: 7
          }
        },
        loc: {
          start: {
            line: 192,
            column: 13
          },
          end: {
            line: 200,
            column: 7
          }
        },
        line: 192
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 182,
            column: 21
          },
          end: {
            line: 182,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 182,
            column: 21
          },
          end: {
            line: 182,
            column: 55
          }
        }, {
          start: {
            line: 182,
            column: 59
          },
          end: {
            line: 182,
            column: 95
          }
        }],
        line: 182
      },
      "1": {
        loc: {
          start: {
            line: 193,
            column: 8
          },
          end: {
            line: 195,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 193,
            column: 8
          },
          end: {
            line: 195,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 193
      },
      "2": {
        loc: {
          start: {
            line: 197,
            column: 8
          },
          end: {
            line: 199,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 197,
            column: 8
          },
          end: {
            line: 199,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 197
      },
      "3": {
        loc: {
          start: {
            line: 197,
            column: 12
          },
          end: {
            line: 197,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 197,
            column: 12
          },
          end: {
            line: 197,
            column: 19
          }
        }, {
          start: {
            line: 197,
            column: 23
          },
          end: {
            line: 197,
            column: 32
          }
        }],
        line: 197
      },
      "4": {
        loc: {
          start: {
            line: 212,
            column: 12
          },
          end: {
            line: 212,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 212,
            column: 23
          },
          end: {
            line: 212,
            column: 31
          }
        }, {
          start: {
            line: 212,
            column: 34
          },
          end: {
            line: 212,
            column: 40
          }
        }],
        line: 212
      },
      "5": {
        loc: {
          start: {
            line: 215,
            column: 12
          },
          end: {
            line: 215,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 215,
            column: 23
          },
          end: {
            line: 215,
            column: 32
          }
        }, {
          start: {
            line: 215,
            column: 35
          },
          end: {
            line: 215,
            column: 39
          }
        }],
        line: 215
      },
      "6": {
        loc: {
          start: {
            line: 221,
            column: 13
          },
          end: {
            line: 221,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 221,
            column: 13
          },
          end: {
            line: 221,
            column: 28
          }
        }, {
          start: {
            line: 221,
            column: 33
          },
          end: {
            line: 221,
            column: 72
          }
        }],
        line: 221
      },
      "7": {
        loc: {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 239,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 239,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 225
      },
      "8": {
        loc: {
          start: {
            line: 229,
            column: 13
          },
          end: {
            line: 229,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 229,
            column: 13
          },
          end: {
            line: 229,
            column: 21
          }
        }, {
          start: {
            line: 229,
            column: 25
          },
          end: {
            line: 229,
            column: 62
          }
        }],
        line: 229
      },
      "9": {
        loc: {
          start: {
            line: 232,
            column: 11
          },
          end: {
            line: 236,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 233,
            column: 50
          }
        }, {
          start: {
            line: 235,
            column: 12
          },
          end: {
            line: 235,
            column: 56
          }
        }],
        line: 232
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "624d8474d97852b7945b5760b09a6cb954b8ba19"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_10uyfywcnq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_10uyfywcnq();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








/**
 * Text buttons are typically used for less-pronounced actions.
 * Link variant variations
 * ------------------------------------------------------------------------------------------------
 *
 * "inline-primary"
 *
 * "inline-secondary"
 *
 * "primary-button"
 *
 * "secondary-button"
 *
 * Link size variations
 * ---------------------------------------------------------------------------------------------
 *
 * "sm"
 *
 * "md"
 *
 * "lg"
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Screen readers handle links slightly differently than they do buttons. All
 * links and buttons are tab-able, but pressing the Space key or Enter
 * triggers a button, whereas pressing the Enter key only triggers a link.
 *
 * **The simplest rule of thumb is to just use the right HTML elements for the
 * content. Realistically, this is not possible 100% of the time—just
 * remember, when using the wrong elements keep in mind there are behaviors
 * and states that may be expected that will need to be accounted for.**
 *
 * Please keep in mind that the functional links that look like button
 * variants (`primary-button` & `secondary-button`) are antipatterns. However
 * for conversion reasons this is occasionally a requirement. Make sure to
 * verify with Design that this behavior is absolutely necessary and
 * appropriate a11y concerns were considered.
 *
 * ###
 *
 * Impact:
 *
 * ####
 *
 * Tab order
 *
 * `<a>` elements without an href attribute are NOT in the tab order.
 * Elements typically not in the tab order can be added by setting the
 * tabindex attribute to 0 on that element.
 *
 * ####
 *
 * Hover and focus states
 *
 * Unlike button and input elements, `<a>` do NOT by default trigger the
 * associated click event on keypress of the `SPACE` keys without additional
 * work.
 *
 * ####
 *
 * Assistive technologies
 *
 * While `<a>` elements are treated uniquely, it's common to identify all
 * links on a page using assistive technologies to more easily navigate
 * throughout a site. Therefore, it might be strange having those intended to
 * be used as a button to be mixed up with the other actual links. Any element
 * intended to be a button not marked up using button or input can have the
 * ARIA role attribute set to button—keep in mind, though, all the
 * behaviors/states above still need to be implemented.
 *
 * If you need to have a functional button that looks like a link, use a
 * `<Button />` component with a link variant:
 *
 * ####
 *
 * ✅ Pass
 *
 * <Button onClick={() => { /* function that does something other than
 * navigation *&#47; }} variant="link" aria-label={null} > Click me!!!
 * </Button>
 *
 *
 * ####
 *
 * 🛑 Fail
 *
 * <Link onClick={() => { /* function that does something other than
 * navigation *&#47; }} href="" aria-label={null} > Click me!!!  </Link>
 *
 *
 * ###
 *
 * Further Reading
 *
 * [Buttons & Links | Accessibility
 * Guidelines](http://web-accessibility.carnegiemuseums.org/content/buttons/)
 * [Proper Use of Buttons and
 * Links](https://www.webaxe.org/proper-use-buttons-links/)  [Links, Buttons,
 * Submits, and Divs, Oh
 * Hell](https://adrianroselli.com/2016/01/links-buttons-submits-and-divs-oh-hell.html)
 * [When To Use The Button Element |
 * CSS-Tricks](https://css-tricks.com/use-button-element/) [The Anchor Button:
 * Bad for Accessibility, Bad for
 * Usability](http://itstiredinhere.blogspot.com/2014/08/the-anchor-button-bad-for-accessibility.html?m=1)
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Link` is set up to track click and impression events:
 *
 * *   To track click events pass in an non-empty `analyticsName` (convention:
 * {appName}-{linkName})
 *
 * *   To track impression events pass: 1) a non-empty `analyticsName` 2) pass
 * `trackImpression={true}`
 *
 *
 * Link impression events will only be tracked the first time that the link
 * enters the viewport
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_link\_view\_event for link
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
var Link = (cov_10uyfywcnq().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_22__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    onClick = _ref.onClick,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    disabled = _ref.disabled,
    href = _ref.href,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_10uyfywcnq().f[0]++;
  var isButton = (cov_10uyfywcnq().s[1]++, (cov_10uyfywcnq().b[0][0]++, props.variant === 'primary-button') || (cov_10uyfywcnq().b[0][1]++, props.variant === 'secondary-button'));
  var styles = (cov_10uyfywcnq().s[2]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_23__/* .useMultiStyleConfig */ .jC)('Link', _objectSpread(_objectSpread({}, props), {}, {
    disabled: disabled
  })));
  var _ref2 = (cov_10uyfywcnq().s[3]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_24__/* .useObservabilitySafe */ .r)()),
    trackJourneyEvent = _ref2.trackJourneyEvent;
  var inViewRef = (cov_10uyfywcnq().s[4]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_24__/* .useTrackComponentInView */ .O)('linkViewEvent', trackImpression, analyticsName));
  var mergedRefs = (cov_10uyfywcnq().s[5]++, (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_25__/* .useMergeRefs */ .qq)(inViewRef, ref));
  var handleClick = (cov_10uyfywcnq().s[6]++, (0,react__WEBPACK_IMPORTED_MODULE_21__.useCallback)(function (e) {
    cov_10uyfywcnq().f[1]++;
    cov_10uyfywcnq().s[7]++;
    if (analyticsName) {
      cov_10uyfywcnq().b[1][0]++;
      cov_10uyfywcnq().s[8]++;
      trackJourneyEvent('platform', 'linkClickEvent', {
        targetName: analyticsName
      });
    } else {
      cov_10uyfywcnq().b[1][1]++;
    }
    cov_10uyfywcnq().s[9]++;
    if ((cov_10uyfywcnq().b[3][0]++, onClick) && (cov_10uyfywcnq().b[3][1]++, !disabled)) {
      cov_10uyfywcnq().b[2][0]++;
      cov_10uyfywcnq().s[10]++;
      onClick(e);
    } else {
      cov_10uyfywcnq().b[2][1]++;
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [analyticsName, onClick, disabled]));
  var linkProps = (cov_10uyfywcnq().s[11]++, _objectSpread({
    /*
     * NOTE: Forcing links to function as buttons to ensure that a11y is handled correctly
     * This is a known antipattern, however for conversion reasons this is occasionally a
     * requirement. Make sure to verify with design that this behavior is absolutely necessary
     * and appropriate a11y concerns were considered.
     */
    role: isButton ? (cov_10uyfywcnq().b[4][0]++, 'button') : (cov_10uyfywcnq().b[4][1]++, 'link'),
    __css: styles.link,
    onClick: handleClick,
    href: disabled ? (cov_10uyfywcnq().b[5][0]++, undefined) : (cov_10uyfywcnq().b[5][1]++, href)
  }, props));
  var iconProps = (cov_10uyfywcnq().s[12]++, {
    __css: styles.icon,
    color: (cov_10uyfywcnq().b[6][0]++, linkProps.color) || (cov_10uyfywcnq().b[6][1]++, styles.link.color),
    size: 16
  });
  cov_10uyfywcnq().s[13]++;
  if (props.variant === 'nav') {
    cov_10uyfywcnq().b[7][0]++;
    cov_10uyfywcnq().s[14]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_26__/* .bricks.a */ .G.a, _extends({
      ref: mergedRefs
    }, linkProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_Flex_index_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
      __css: styles.content
    }, (cov_10uyfywcnq().b[8][0]++, leftIcon) && (cov_10uyfywcnq().b[8][1]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_Icon_index_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, _extends({}, iconProps, leftIcon))), children), rightIcon ? (cov_10uyfywcnq().b[9][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_Icon_index_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, _extends({}, iconProps, rightIcon))) : (cov_10uyfywcnq().b[9][1]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_Icon_index_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, _extends({}, iconProps, {
      name: "chevron-right"
    }))));
  } else {
    cov_10uyfywcnq().b[7][1]++;
  }
  cov_10uyfywcnq().s[15]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_26__/* .bricks.a */ .G.a, _extends({
    ref: mergedRefs
  }, linkProps), children);
}));
/* harmony default export */ __webpack_exports__["Z"] = (Link);

/***/ })

}]);